import { render, staticRenderFns } from "./ReferenceMovement.vue?vue&type=template&id=c2d5f266&scoped=true&"
import script from "./ReferenceMovement.vue?vue&type=script&lang=ts&"
export * from "./ReferenceMovement.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceMovement.vue?vue&type=style&index=0&id=c2d5f266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d5f266",
  null
  
)

export default component.exports